import React from 'react';
import { useNavigate } from 'react-router-dom';

import RightArrow from '../../Icons/icons/RightArrow';
import AvatarComponent from '../AvatarComponent/AvatarComponent';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import { timeAgo } from '@/utils/ts/stringUtils';
import { getSocialCampaignDetailRoute } from '@/config/baseRoutes';

const UsageRightNotification = ({ notification }) => {
  const navigate = useNavigate();

  return (
    <div className={`post-tracking-notification-container ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent
          src={notification?.content?.profileImg}
          alt={notification?.content?.fullName || notification?.content?.user_name}
        />
      </div>
      <div className="right-container">
        <div className="title">{notification?.title}</div>
        <div>
          <ButtonComponent
            variant="text-highlight"
            style={{ padding: 0 }}
            textStyle={{fontSize:"14px"}}
            onClick={() => {
              navigate(getSocialCampaignDetailRoute(notification?.content?.campaignId), {
                state: { usageRightId: notification?.content?.usageRightId },
              });
            }}
            rightIcon={<RightArrow color="var(--purple-p-400)" />}>
            Check it Out{' '}
          </ButtonComponent>
        </div>
        <p className="timestamp">
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
};

export default UsageRightNotification;
